export default __webpack_public_path__ + "static/media/heart-no.f95592d5.svg";